import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { Page } from '../../model/page';
import { UrlLinkDirective } from '../url-link.directive';

@Component({
  selector: 'pagination',
  imports: [UrlLinkDirective],
  host: {
    style: 'display: contents'
  },
  template: `
    @if (numbers().length > 1) {
      <!-- Pagination -->
      <div class="pagination flex-m flex-w p-t-26">
        @for (number of numbers(); track $index) {
          <a class="item-pagination flex-c-m trans-0-4"
            [storefrontUrl]="url(number)"
            [class.active-pagination]="number === current()">
            {{number ?? '...'}}
          </a>
        }
      </div>
    }
    `
})
export class PaginationComponent {

  readonly page = input<Page<unknown>>();

  private router = inject(Router);

  readonly current = computed(() => (this.page()?.number ?? 0) + 1);
  readonly numbers = computed(() => window(this.current(), this.page()?.totalPages ?? 0));

  url(number: number | null): string | null {
    if (number === null) {
      return null;
    }
    const url = new URL(this.router.url, 'http://storefront');
    if (number === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(number - 1));
    }
    return url.pathname + url.search;
  }

}

function window(current: number, totalPages: number): (number | null)[] {
  if (totalPages <= 10) {
    return Array.from({ length: totalPages }, (unused, index) => index + 1);
  }
  const first = [1, 2];
  const around = [current - 2, current - 1, current, current + 1, current + 2];
  const last = [totalPages - 1, totalPages];
  const shown = [...first, ...around, ...last]
    .filter(number => number > 0 && number <= totalPages)
    .filter((number, index, all) => all.indexOf(number) === index);
  return withGaps(shown);
}

function withGaps(shown: number[]): (number | null)[] {
  const filled: (number | null)[] = [];
  shown.forEach((number, index) => {
    const previous = shown[index - 1];
    if (previous !== undefined && number - previous === 2) {
      filled.push(number - 1);
    } else if (previous !== undefined && number - previous > 2) {
      filled.push(null);
    }
    filled.push(number);
  });
  return filled;
}
